import { render, staticRenderFns } from "./QualificationsDetail.vue?vue&type=template&id=5ff1ea3c&scoped=true&"
import script from "./QualificationsDetail.vue?vue&type=script&lang=js&"
export * from "./QualificationsDetail.vue?vue&type=script&lang=js&"
import style0 from "./QualificationsDetail.vue?vue&type=style&index=0&id=5ff1ea3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff1ea3c",
  null
  
)

export default component.exports